module.exports = __webpack_public_path__ + "static/media/icons-help.1391483e.svg";